<template lang="pug">
  v-row.consultation--field-row(v-if="isFieldValid" :class="rowClass")
    v-col.d-flex.align-center(:sm="hideValue ? 12 : 5" :class="indentClass")
      label.primary--text(v-if="field.question" :id="`dynamic-field-question-${ field.id }`" :class="labelClass")
        span(:style="`font-weight: ${ fontWeight }`") {{ field.question }}
        n-info-tooltip.ml-2(v-if="field.info_text" :info-text="field.info_text")

    v-col.d-flex.align-center.col-value(v-if="!hideValue" sm="7")
      template(v-if="field.is_calculated || isReadonly")
        .field-value.pr-0(:class="[ nextField && 'attach-next', valueClass, fieldClass ]") {{ getFormattedValue(field) }}

      template(v-else)
        .field-input(
          :class="nextField && 'attach-next'"
          :style="`max-width: ${ fieldWidth }%`"
        )
          dynamic-field(:field="field" @update="(id, v) => $emit('update', id, v)")

      template(v-if="nextField")
        .field-value(v-if="nextField.is_calculated || isReadonly" :class="valueClass") {{ getFormattedValue(nextField) }}

        .field-input(
          v-else
          :style="`max-width: ${ nextFieldWidth }%`"
        )
          dynamic-field(:field="nextField" @update="(id, v) => $emit('update', id, v)")

    v-col.pt-0(v-if="field.hint_text" sm="12" :class="indentClass")
      template(v-if="isConcept || isStatus")
        .d-flex.align-start.hint-text(:class="labelClass")
          svg-warning.red--text(v-if="field.hint_class === 'red--text'")
          svg-check(v-else-if="field.hint_class === 'green--text'")
          svg-info.primary--text(v-else)
          span.ml-2 {{ field.hint_text }}

        .hint-text.mt-1(v-if="nextField" :class="labelClass")
          .d-flex.align-start.hint-text(:class="labelClass")
            svg-warning.red--text(v-if="nextField.hint_class === 'red--text'")
            svg-check(v-else-if="nextField.hint_class === 'green--text'")
            svg-info.primary--text(v-else)
            span.ml-2 {{ nextField.hint_text }}

      template(v-else)
        .hint-text(:class="[ labelClass, field.hint_class ]") {{ field.hint_text }}
        .hint-text.mt-1(v-if="nextField" :class="[ labelClass, nextField.hint_class ]") {{ nextField.hint_text }}

    v-col.pt-0(v-if="isDebugMode" sm="12" :class="indentClass")
      .debug-info(:class="labelClass") {{ getDebugInfo(field) }}
      .debug-info.mt-1(v-if="nextField" :class="labelClass") {{ getDebugInfo(nextField) }}

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    DynamicField: () => import('./dynamic-field'),
    SvgCheck: () => import('@/components/svgs/svg-check'),
    SvgInfo: () => import('@/components/svgs/svg-info'),
    SvgWarning: () => import('@/components/svgs/svg-warning'),
  },
})
export default class FieldRow extends Vue {
  @Prop({ type: Object, default: () => {} }) field
  @Prop({ type: String, default: '' }) labelClass
  @Prop({ type: String, default: '' }) valueClass
  @Prop({ type: Boolean, default: false }) forceEdit
  @Prop({ type: Boolean, default: false }) hideValue

  get isFieldValid () {
    if (this.field.hidden) {
      return false
    }

    if (this.field.sort_index === 9998 || this.field.sort_index === 9999) {
      if (!this.field.value && this.isStatus) {
        return false
      }
    }

    return this.field.question || this.field.value || this.field.hint_text
  }

  get isReadonly () {
    if (this.forceEdit) {
      return false
    }
    return this.isOutput
  }

  get fieldClass () {
    if (!this.showEmptyNotice || this.isStatus) {
      return ''
    }

    return this.field.value === null || this.field.value === ''
      ? 'lime lighten-5'
      : ''
  }

  get indentClass () {
    const indentCls = this.field.styling && this.field.styling.indent
      ? 'pl-8'
      : ''

    return indentCls
  }

  get rowClass () {
    return (this.field.sort_index === 9998 || this.field.sort_index === 9999 || this.field.sort_index === 9999999)
      ? 'notice-field-row'
      : ''
  }

  get fontWeight () {
    return this.field.styling && this.field.styling.font_weight
      ? this.field.styling.font_weight
      : ''
  }

  get fieldWidth () {
    if (!this.nextField) {
      return 100
    }

    return this.field.styling && this.field.styling.width
      ? this.field.styling.width * 100
      : 50
  }

  get nextFieldWidth () {
    if (!this.nextField) {
      return 0
    }

    if (this.nextField.styling && this.nextField.styling.width) {
      return this.nextField.styling.width * 100
    }

    return 100 - this.fieldWidth
  }

  get nextField () {
    return this.field.next_field
      ? this.field.next_field
      : null
  }
}
</script>

<style lang="sass">
.consultation--field-row
  margin: 0 -12px

  .field-input,
  .field-value
    flex: 1 1 100%

  .field-value
    display: flex
    height: 100%
    align-items: flex-end

  .attach-next
    padding-right: 12px

    &.field-input + .field-value
      align-items: center

  .hint-text
    font-size: 14px
    color: #666

    i.fo
      margin-top: 1px

    svg
      width: auto
      height: 18px
      min-width: 18px

  &.concept-field
    position: relative
    top: -10px
    left: 100px
    width: calc(100% - 100px)
</style>
